import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokSpotsComponent } from '../../app/content/modules/storyblok/components/storyblok-spots/storyblok-spots.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

function createSpot(overrides: Record<string, unknown> = {}) {
  return {
    _uid: `spot-${Math.random().toString(36).slice(2, 8)}`,
    title: 'Sommerudsalg',
    description: 'Spar op til 40% på udvalgte vine',
    ctaText: 'Se tilbud',
    ctaLink: { cached_url: '/tilbud' },
    ctaDesign: '',
    backgroundImage: { filename: 'https://a.storyblok.com/f/placeholder/800x400' },
    height: '300',
    col: 'col-md-6',
    ...overrides,
  };
}

const meta: Meta<StoryblokSpotsComponent> = {
  title: 'Storyblok/Spots',
  component: StoryblokSpotsComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Grid of promotional spot cards. Each spot has a background image, title, description, and CTA.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokSpotsComponent>;

export const TwoSpots: Story = {
  args: {
    body: [
      createSpot({ title: 'Rødvin i topklasse', description: 'Udforsk vores bedste rødvine', ctaText: 'Se rødvin' }),
      createSpot({ title: 'Hvidvin til sommer', description: 'Friske hvidvine til varme dage', ctaText: 'Se hvidvin' }),
    ],
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-spots')).toBeTruthy();
  },
};

export const ThreeSpots: Story = {
  args: {
    body: [
      createSpot({ col: 'col-md-4', title: 'Frankrig', ctaText: 'Se franske vine', ctaLink: { cached_url: '/frankrig' } }),
      createSpot({ col: 'col-md-4', title: 'Italien', ctaText: 'Se italienske vine', ctaLink: { cached_url: '/italien' } }),
      createSpot({ col: 'col-md-4', title: 'Spanien', ctaText: 'Se spanske vine', ctaLink: { cached_url: '/spanien' } }),
    ],
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-spots')).toBeTruthy();
  },
};

export const SingleSpotFullWidth: Story = {
  args: {
    body: [
      createSpot({ col: 'col-12', title: 'Black Friday', description: 'De bedste tilbud hele ugen', ctaText: 'Shop nu', ctaDesign: 'purple' }),
    ],
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-spots')).toBeTruthy();
  },
};

export const SpotsWithoutCta: Story = {
  args: {
    body: [
      createSpot({ title: 'Vinskole', description: 'Lær om vin med vores eksperter', ctaText: '', ctaLink: { cached_url: '' } }),
      createSpot({ title: 'Smagninger', description: 'Deltag i vores næste vinsmagning', ctaText: '', ctaLink: { cached_url: '' } }),
    ],
    general_styling: [],
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-spots')).toBeTruthy();
  },
};
